export default "__VITE_ASSET__CHy2DDWB__"